<template>
  <div>
    <WarrantyPeriodSetting></WarrantyPeriodSetting>
  </div>
</template>

<script>
import WarrantyPeriodSetting from "@/components/shoplus_authservice/warranty_period/WarrantyPeriodSetting.vue";
export default {
  components: {
    WarrantyPeriodSetting
  }
};
</script>
